import type { SliceComponentProps } from "@commercekit/prismic";
import { FooterReviews } from "~/components/atoms/WvReview";
import type { CustomerReviewsBigSlice } from "~/lib/prismic";

const CustomerReviewsBig = ({
  slice,
}: SliceComponentProps<CustomerReviewsBigSlice>) => (
  <>
    <span className="footer__quote">“</span>
    <div className="container">
      <div className="p-4 mx-auto text-center footer__reviews">
        <div className="pb-3 heading handwritten footer__reviews-title">
          {slice.primary.title}
        </div>
        <div className="footer__review">{slice.primary.review}</div>
        <FooterReviews rating={slice.primary.rating} />
        {/* <div className="footer__stars">
            <span data-icon-before=""></span>
            <span data-icon-before=""></span>
            <span data-icon-before=""></span>
            <span data-icon-before=""></span>
            <span data-icon-before=""></span>
          </div> */}
        <div className="mt-2 mb-4 heading lg handwritten footer__reviews-name">
          {slice.primary.name}
        </div>
        <a
          href="/reviews/"
          className="btn btn--primary d-inline-block sentence-case"
          data-icon-after=""
        >
          {slice.primary.link_text}
        </a>
      </div>
    </div>
  </>
);

export default CustomerReviewsBig;
